import { css } from '@emotion/react';

export const styles = {
  wrapper: css`
    padding: 20px 24px;

    font-size: 14px;
    line-height: 1.6;
    color: #374151;
  `,

  header: css`
    margin-bottom: 16px;
  `,

  title: css`
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #111827;
  `,

  location: css`
    margin-top: 4px;
    font-size: 13px;
    color: #9ca3af;
  `,

  skills: css`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;

    span {
      padding: 4px 10px;
      border-radius: 999px;
      background: #e5e7eb;
      font-size: 12px;
      color: #4b5563;
    }
  `,

  section: css`
    margin-top: 16px;

    h4 {
      margin-bottom: 6px;
      font-size: 13px;
      font-weight: 500;
      color: #111827;
    }

    ul {
      padding-left: 18px;
      margin: 0;
    }

    li {
      margin-bottom: 4px;
    }

    p {
      margin: 0;
    }
  `,

  apply: css`
    display: inline-block;
    margin-top: 20px;

    padding: 10px 18px;
    border-radius: 999px;

    background: #6c3bff;
    color: white;
    text-decoration: none;
    font-size: 13px;

    transition: 0.2s;

    &:hover {
      background: #5a2fe0;
    }
  `,
  preserveText: css`
    margin: 0;
    white-space: pre-line;
  `,
};
